import classNames from 'classnames';
import { ForwardedRef } from 'react';

import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/pill-button.module.css';

export interface PillButtonProps extends BasicButtonProps {
    branded?: boolean;
    bordered?: boolean;
    compact?: boolean;
    active?: boolean;
}

function PillButton({
    branded = false,
    bordered = false,
    compact = false,
    active = false,
    className = null,
    ref: buttonRef = null,
    ...props
}: PillButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            className={classNames([
                styles.container,
                {
                    [styles.branded]: branded,
                    [styles.compact]: compact,
                    [styles.bordered]: bordered,
                    [styles.active]: active,
                },
                className,
            ])}
            ref={buttonRef}
            {...props}
        />
    );
}

export default PillButton;
